module.exports = __webpack_public_path__ + "media/application/images/header/arrow-down-67de61688e641fecde54dd2ec127ac76.svg";